import React from "react";
import FullHistoryRow from "./FullHistoryRow";
import {thStyles} from "./tableStyles";

export const FullHistory = ({authorName, history: {recommendations}}) => (
    <div>
        <h3 style={{color: "#28313E", margin: "20px 20px 0 20px", fontSize: "100%"}}>{authorName}'s History on All Instruments</h3>
        <div style={{margin: "0 20px"}}>
            <table style={{width: "100%"}}>
                <thead>
                    <tr>
                        <th style={thStyles}>Communication Date</th>
                        <th style={thStyles} colSpan="3"/>
                        <th style={thStyles}>Target Price</th>
                        <th style={thStyles}>Market Price</th>
                        <th style={thStyles}>Validity Period</th>
                    </tr>
                </thead>
                <tbody>
                {recommendations.map(r => <FullHistoryRow key={r.id} {...r} />)}
                </tbody>
            </table>
        </div>
    </div>
);
FullHistory.propTypes = {
    history: React.PropTypes.shape({
        recommendations: React.PropTypes.array,
        loading: React.PropTypes.bool
    }),
    authorName: React.PropTypes.string
};
FullHistory.defaultProps = {
    history: []
};

export default FullHistory;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/FullHistory.js
 **/